import { nextCargoApi } from "../../baseApi";
import { GetQueueOvertimeHistoryByCompany, GetQueueOvertimeOpenByCompany } from "./queue-overtime.types";

export const queueOvertimeApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getQueueOvertimeOpenByCompany: build.query<GetQueueOvertimeOpenByCompany["response"], GetQueueOvertimeOpenByCompany["args"]>({
      query: ({ id }) => `/queue-overtime/company/${id}/open`
    }),
    getQueueOvertimeHistoryByCompany: build.query<GetQueueOvertimeHistoryByCompany["response"], GetQueueOvertimeHistoryByCompany["args"]>({
      query: ({ id, days = 30 }) => ({
        url: `/queue-overtime/company/${id}/history`,
        params: { days },
        method: "GET"
      })
    })
  })
});
